import React from "react";

const Invert = ({ color }) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="24"
    //   height="24"
    //   viewBox="0 0 24 24"
    //   fill="none"
    // >
    //   <path
    //     d="M20 5H16.8L15.6 3.66C15.22 3.24 14.68 3 14.11 3H9.89C9.32 3 8.78 3.24 8.4 3.66L7.2 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 18C20 18.55 19.55 19 19 19H12V18C9.2 18 7 15.8 7 13C7 10.2 9.2 8 12 8V7H19C19.55 7 20 7.45 20 8V18ZM17 13C17 10.2 14.8 8 12 8V9.8C13.8 9.8 15.2 11.2 15.2 13C15.2 14.8 13.8 16.2 12 16.2V18C14.8 18 17 15.8 17 13ZM8.8 13C8.8 14.8 10.2 16.2 12 16.2V9.8C10.2 9.8 8.8 11.2 8.8 13Z"
    //     fill={color}
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.32 1.77778H16.2C17.19 1.77778 18 2.57778 18 3.55556V14.2222C18 15.2 17.19 16 16.2 16H1.8C0.81 16 0 15.2 0 14.2222V3.55556C0 2.57778 0.81 1.77778 1.8 1.77778H4.68L6.3 0H11.7L13.32 1.77778ZM9 14.2223H16.2V3.55566H9V4.44434C11.52 4.44434 13.5 6.39989 13.5 8.88878C13.5 11.3777 11.52 13.3332 9 13.3332V11.7332C10.62 11.7332 11.88 10.4888 11.88 8.88878C11.88 7.28878 10.62 6.04434 9 6.04434L9 11.7328C7.38 11.7328 6.12 10.4884 6.12 8.88839C6.12 7.28839 7.38 6.04395 9 6.04395L9 4.44455C6.48 4.44455 4.5 6.40011 4.5 8.889C4.5 11.3779 6.48 13.3334 9 13.3334V14.2223Z"
        fill={color}
      />
    </svg>
  );
};

export default Invert;
